import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./router/AppRoutes";
import ScrollToTop from './helpers/ScrollToTop'
const App = () => {
  return (
    <BrowserRouter>
    <ScrollToTop/>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;